'use client';
import classNames from 'classnames';
import { Flex, Link, Text, Title } from '@gjensidige/builders-components';
import { ArrowRight } from '@gjensidige/builders-icons';
import type { CtaBannerProps as Props } from './types';
import styles from './cta-banner.module.less';

export const CtaBanner = ({
  title,
  text,
  link,
  symbol,
  backgroundColor: color = 'blue'
}: Props) => (
  <Flex
    as={Link}
    center
    className={classNames(styles.ctaBanner, styles.marginYParts, styles[color])}
    direction="column"
    fill
    gap="sm xl"
    href={link.url}
    target={link.newWindow ? '_blank' : undefined}
    tracking={{
      eventLabel: link.trackingLabel || `cta-banner-module_${link.url}`,
      eventModule: 'cta-banner-module',
      eventSource: '@gjensidige/parts-cta-banner',
      eventVersion: '1.0.0'
    }}
  >
    {!!symbol && <img alt="" src={symbol} height="159" width="163" />}
    <Flex
      align="center"
      gap="sm xl"
      layout={{ xs: 1, md: symbol || !text ? 1 : 2 }}
    >
      <Title size="4" className={styles.title} text={title} />
      {!!text && (
        <Text
          as="div"
          className={styles.htmlArea}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </Flex>
    <ArrowRight className={styles.arrowStatic} />
    <svg viewBox="0 0 60 32" className={styles.arrowAnimate}>
      <line x1="16" y1="16" x2="65" y2="16" />
      <line x1="0" y1="0" x2="16" y2="16" />
      <line x1="0" y1="32" x2="16" y2="16" />
    </svg>
  </Flex>
);
